import {Component} from 'react';

class AwardDetailListCard extends Component {
  constructor(props) {
    super(props);
    this.state={
   
    }   
}
  
render() {
         
return <>
      <tr>
          <td className="text-left font-weight-bold" >
               {this.props.rptInfo.awardType}
          </td>
          <td className="text-left" >
               {this.props.rptInfo.awardCode}
          </td>
          <td className="text-left" >
               {this.props.rptInfo.awardName}
          </td>
     </tr>         
           
   </>
  }
}

export default AwardDetailListCard;